/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Profile`)
};

const zh_hans1_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const zh_hant1_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存`)
};

const fr_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le profil`)
};

const de_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil speichern`)
};

const ja_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールを保存`)
};

const ko_settings_update_profile = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필 저장`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_update_profile = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_update_profile(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_update_profile", locale)
	if (locale === "en") return en_settings_update_profile(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_update_profile(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_update_profile(inputs)
	if (locale === "fr") return fr_settings_update_profile(inputs)
	if (locale === "de") return de_settings_update_profile(inputs)
	if (locale === "ja") return ja_settings_update_profile(inputs)
	return ko_settings_update_profile(inputs)
};